import { useContext } from "react";
import { AuthContext } from "../components/AuthContextProvider";
import { Role } from "../../generated/types";

export function useIsReferral() {
  const { accessToken, role } = useContext(AuthContext);

  return accessToken !== undefined && role === Role.Referral;
}
